<template>
  <v-container>
    <div class="title mb-4">Input</div>
    <v-text-field label="Token" outlined v-model="model.token"></v-text-field>
    <v-text-field label="Course" outlined v-model="model.course"></v-text-field>
    <v-text-field
      label="Num Stamp"
      outlined
      v-model.number="model.numStamp"
    ></v-text-field>
    <v-btn color="primary" depressed @click="enc">Encrypt</v-btn>
    <v-divider class="my-4"></v-divider>
    <div class="title mb-4">Result</div>
    <div>
      <v-textarea v-model="result"></v-textarea>
    </div>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    model: {
      token: "",
      course: "",
      numStamp: null,
    },
    result: "",
  }),
  methods: {
    enc() {
      if (this.model.numStamp == null || this.model.numStamp == 0) {
        this.model.numStamp = Date.now();
      }

      let rawStr = JSON.stringify(this.model);

      let encrypted = this.$crypto.AES.encrypt(
        rawStr,
        this.$store.state.secretKey
      );

      this.result = encodeURIComponent(encrypted.toString());
    },
  },
};
</script>